import React, { useState } from 'react';
import { FadeInSection } from './FadeInSection';
import { useLanguage } from './LanguageContext';
import { translations } from './translations';
import { ChevronLeft, ChevronRight, Star } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export const Testimonials = () => {
  const {
    lang
  } = useLanguage();
  const t = translations[lang].testimonials;
  const [currentIndex, setCurrentIndex] = useState(0);
  const next = () => {
    setCurrentIndex(prev => (prev + 1) % t.quotes.length);
  };
  const prev = () => {
    setCurrentIndex(prev => (prev - 1 + t.quotes.length) % t.quotes.length);
  };
  return <FadeInSection className="relative w-full py-32 lg:py-40 overflow-hidden" data-id="element-264" data-mp="2x11ri34ofdvv">
      {/* Background */}
      <div className="absolute inset-0 z-0" data-id="element-265" data-mp="2s3t8y1fm97u3">
        <img src="https://images.unsplash.com/photo-1570129477492-45c003edd2be" alt="Luxury Home Interior" className="w-full h-full object-cover" data-id="element-266" data-mp="v9ydr4zhpj73" />
        <div className="absolute inset-0 bg-black/65" data-id="element-267" data-mp="h67wpwq6ta6o" />
      </div>

      <div className="relative z-10 max-w-5xl mx-auto px-6 lg:px-12 flex flex-col items-center text-center" data-id="element-268" data-mp="h818trjkkmm2">
        <span className="eyebrow mb-4 text-white/90" data-id="element-269" data-mp="m2onyzsoo4nz">{t.eyebrow}</span>
        <h2 className="font-serif-display text-3xl md:text-4xl uppercase tracking-wider text-white mb-20" data-id="element-270" data-mp="79bols47aq2n">
          {t.headline}
        </h2>

        <div className="relative w-full min-h-[250px] flex items-center justify-center" data-id="element-271" data-mp="zwppg1b0s5s1">
          {/* Navigation Arrows */}
          <button onClick={prev} className="absolute left-0 top-1/2 -translate-y-1/2 text-[#c9a96e] hover:text-white transition-colors p-2 z-20 hidden md:block" data-id="element-272" data-mp="14vsmayguj5ox">
            <ChevronLeft size={48} strokeWidth={1} data-id="element-273" data-mp="v4xyvqrv601w" />
          </button>

          <button onClick={next} className="absolute right-0 top-1/2 -translate-y-1/2 text-[#c9a96e] hover:text-white transition-colors p-2 z-20 hidden md:block" data-id="element-274" data-mp="1ivk3t96kn47o">
            <ChevronRight size={48} strokeWidth={1} data-id="element-275" data-mp="1xhqwxlkg5msf" />
          </button>

          {/* Carousel Content */}
          <div className="w-full md:w-3/4 px-4" data-id="element-276" data-mp="1sieav31egjqw">
            <AnimatePresence mode="wait" data-id="element-277" data-mp="1sjpdv0n0tngy">
              <motion.div key={currentIndex} initial={{
              opacity: 0,
              y: 20
            }} animate={{
              opacity: 1,
              y: 0
            }} exit={{
              opacity: 0,
              y: -20
            }} transition={{
              duration: 0.5
            }} className="flex flex-col items-center" data-id="element-278" data-mp="1oh2jot2vnqgl">
                <div className="flex space-x-1 mb-8" data-id="element-279" data-mp="10sj926wcv1lc">
                  {[...Array(5)].map((_, i) => <Star key={i} size={20} className="fill-[#c9a96e] text-[#c9a96e]" data-id="element-280" data-mp="vswzc7fqk3ha" data-mpi={i} />)}
                </div>

                <p className="font-serif-cormorant italic text-2xl md:text-4xl text-white leading-relaxed mb-10" data-id="element-281" data-mp="32g4b9c848spu">
                  "{t.quotes[currentIndex].text}"
                </p>

                <span className="uppercase tracking-[0.2em] text-sm text-[#c9a96e] font-medium" data-id="element-282" data-mp="3cg4xp71a7oy9">
                  {t.quotes[currentIndex].author}
                </span>
              </motion.div>
            </AnimatePresence>
          </div>
        </div>

        {/* Mobile Navigation */}
        <div className="flex space-x-6 mt-12 md:hidden" data-id="element-283" data-mp="2oopqp0yk8jgo">
          <button onClick={prev} className="text-[#c9a96e]" data-id="element-284" data-mp="2onejss9tivlc">
            <ChevronLeft size={32} strokeWidth={1} data-id="element-285" data-mp="2sqazob7z4dll" />
          </button>
          <button onClick={next} className="text-[#c9a96e]" data-id="element-286" data-mp="2xickwmn4denr">
            <ChevronRight size={32} strokeWidth={1} data-id="element-287" data-mp="2xjxeoa1m0tkk" />
          </button>
        </div>
      </div>
    </FadeInSection>;
};